// removed by extract-text-webpack-plugin
module.exports = {"text800":"_2NvmrE7aPhXwSr7ayiZxYE","text700":"_1umF_qSKaD7BL2diH3eXJs","text600":"Ni37kWOwvqW3vnNFiZ91T","text500":"_3cMF0mPb2y4vmKyQK3jpPS","text400":"_1BIJkEvwIIuaPwaXTXyqiK","text300":"_3qBkVSbH1ScFW5q--X9e4z","text200":"_3P-z5P7FJitbAEw9T5ZrRJ","textParagraph":"g3BBNa4NxQw3UYq9TZOlE","crimp":"_2g4o4NaLSP5yTApFTZSQfx","trim":"_3Gus-ZYEkiyOvEIOfq-wOp","flexCenter":"_2rdWm8sxZAHy7xyZHdbRAR","hideTextOverflow":"_19MFT7afWC8rvxIRbLqcfa","marginPageMainContent":"_3OIpW5yYJTRZfARYgRAVDO","header":"_12vCruBU5MM6_3YUsCArwS","showOnLarge":"_1B-fuZXQbU2iZty2b5wAwr"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageHeader/styles.scss
// module id = 801
// module chunks = 0